/* Noorns redesign: report page behavior (sections/noorns-product.liquid).
   Mockup behavior: directions/warm-illustration-v3/site.js (gallery thumbs, the buy bar, "Top").
   Add to cart posts to Shopify's cart and tells Horizon's cart drawer, the same way Horizon's
   own product form does (assets/product-form.js): a CartLinesUpdateEvent with a promise that
   resolves with the cart and the re-rendered cart sections. If anything fails, the form posts
   normally and Shopify opens the cart page. */
(function () {
  var root = document.getElementById('noorns-product');
  if (!root) return;

  /* gallery: a thumbnail swaps the main picture */
  root.querySelectorAll('.thumb').forEach(function (t) {
    t.addEventListener('click', function () {
      var im = document.getElementById('product-image');
      if (!im) return;
      im.src = t.getAttribute('data-src');
      if (t.getAttribute('data-srcset')) im.srcset = t.getAttribute('data-srcset');
      im.alt = t.getAttribute('data-alt') || '';
      /* Approved report and bundle galleries carry captions in data-cap. */
      var cap = t.getAttribute('data-cap'), fc = document.getElementById('product-image-caption');
      if (cap !== null && fc) fc.textContent = cap;
      root.querySelectorAll('.thumb').forEach(function (x) { x.removeAttribute('aria-current'); });
      t.setAttribute('aria-current', 'true');
    });
  });

  /* Horizon 4.2 scrolls an inner box (.page-wrapper) on wide screens and the window on phones,
     so scrolling and "Top" use whichever is scrolling */
  var scroller = function () {
    var el = root.parentElement;
    while (el && el !== document.body && el !== document.documentElement) {
      var oy = getComputedStyle(el).overflowY;
      if ((oy === 'auto' || oy === 'scroll') && el.scrollHeight > el.clientHeight + 1) return el;
      el = el.parentElement;
    }
    return window;
  };

  /* "Top" in the buy bar */
  root.addEventListener('click', function (ev) {
    var t = ev.target.closest('.to-top-link');
    if (!t) return;
    ev.preventDefault();
    var rm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    scroller().scrollTo({ top: 0, behavior: rm ? 'auto' : 'smooth' });
    var h = document.getElementById('product-title');
    if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
  });

  /* the buy bar shows once the main Add to cart has scrolled above the screen */
  var bar = document.getElementById('buy-bar'), main = document.getElementById('add-to-cart');
  if (bar && main) {
    var tick = false;
    var upd = function () {
      var off = main.getBoundingClientRect().bottom < 0;
      bar.classList.toggle('show', off);
      bar.setAttribute('aria-hidden', String(!off));
      bar.inert = !off;
      tick = false;
    };
    document.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(upd); } }, { passive: true, capture: true });
    window.addEventListener('resize', upd, { passive: true });
    upd();
  }

  /* add to cart */
  var form = document.getElementById('npdp-form');
  if (!form) return;
  var busy = false;
  form.addEventListener('submit', async function (ev) {
    ev.preventDefault();
    if (busy) return;
    busy = true;
    var buttons = document.querySelectorAll('#add-to-cart, #buy-bar-button');
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var id = form.querySelector('input[name="id"]').value;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var sectionIds = Array.prototype.map.call(document.querySelectorAll('cart-items-component'), function (x) { return x.dataset.sectionId; }).filter(Boolean);
    var ev_mod = null, deferred = null;
    try { ev_mod = await import('@shopify/events'); } catch (e) { ev_mod = null; }
    if (ev_mod && ev_mod.CartLinesUpdateEvent) {
      deferred = ev_mod.CartLinesUpdateEvent.createPromise();
      form.dispatchEvent(new ev_mod.CartLinesUpdateEvent({
        action: 'add', context: 'product',
        lines: [{ merchandiseId: String(id), quantity: 1 }],
        promise: deferred.promise
      }));
    }
    try {
      var r = await fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionIds.join(',') })
      });
      var res = await r.json();
      if (!r.ok || res.status) throw new Error(res.description || res.message || 'Add to cart failed');
      var cart = await (await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })).json();
      if (deferred) {
        deferred.resolve({
          cart: ev_mod.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'product-form-component', sourceId: form.id, itemCount: 1,
                    productId: root.getAttribute('data-product-id'), sections: res.sections, didError: false }
        });
      }
      if (!document.querySelector('cart-drawer-component')) { window.location.href = base + 'cart'; }
    } catch (err) {
      if (deferred) { try { deferred.reject(err); } catch (e) {} }
      HTMLFormElement.prototype.submit.call(form); /* plain post: Shopify adds the item and opens the cart page */
    } finally {
      busy = false;
      buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
    }
  });
})();
